class ProductTile extends HTMLElement {
  constructor() {
    super();
    this.btnEventListeners();
  }

  btnEventListeners() {
    const { productTileButtons } = this.tilesComponents();

    productTileButtons.forEach((button) => {
      button.addEventListener("click", () => {
        let target = button.dataset.action;
        this.toggleTileContent(target);
        this.setActiveClass(button);
      });
    });
  }

  toggleTileContent(target) {
    const targetElement = this.querySelector(`#${target}`);
    if (targetElement != null) {
      this.hideAllTiles();
      targetElement.classList.remove("hidden");
    }
  }

  hideAllTiles() {
    const { contentTiles } = this.tilesComponents();
    contentTiles.forEach((tile) => {
      tile.classList.add("hidden");
    });
  }

  setActiveClass(target) {
    const { productTileButtons } = this.tilesComponents();
    productTileButtons.forEach((button) => {
      button.classList.remove("active");
    });
    target.classList.add("active");
  }

  tilesComponents() {
    const productTileButtons = this.querySelectorAll(".product-tile-button");
    const contentTiles = this.querySelectorAll(".info-tile-content-element");

    return { productTileButtons, contentTiles };
  }
}

customElements.define("product-tiles", ProductTile);
